import { React, AppTextLabel, Loader, AppAsyncButton } from '@@commons';
import { ItemsPickerItem } from './item';

export interface IItemsPickerProps {
    selection: any[];
    itemsRenderer: (item) => any;
    onPick: (arg: React.MouseEvent<any>) => void;
    updateButtonI18nTrad?: string;
    className?: string;
    isLoading?: boolean;
    readOnly?: boolean;
    placeholderText?: string;
    onItemClicked?: (item) => void;
    onRemoveItem?: (item: any) => void;
    onUpdateItem?: (item: any) => void | Promise<void>;
}

export class ItemsPicker extends React.Component<IItemsPickerProps, any> {
    pick = (arg: React.MouseEvent<any>) => {
        arg.preventDefault();
        arg.stopPropagation();
        return this.props.onPick(arg);
    };

    render() {
        let content = null;

        if (this.props.isLoading) {
            content = <div className={"pseudoinput" + (this.props.readOnly ? " readonly" : "")}><Loader /></div>;
        } else {
            let items = [];

            if (this.props.selection && this.props.selection.length) {
                items = this.props.selection.map((item, idx) => {
                    return <ItemsPickerItem {...this.props} key={"item#" + item.id + "#" + idx} item={item} />;
                });
            } else if (this.props.placeholderText) {
                items.push(<div key="placeholder" className="iw-itemspicker-placeholder">
                    <AppTextLabel i18n={this.props.placeholderText} defaultText={this.props.placeholderText} /></div>);
            }

            if (!this.props.readOnly) {
                items.push(<AppAsyncButton key="btnupdate" onClick={this.pick} className="btnupdate">
                    <AppTextLabel i18n={this.props.updateButtonI18nTrad ?? "actions.update"} /></AppAsyncButton>);
            }
            const inputContent = <div className="iw-itemspicker-items">{items}</div>;

            content = <div className={"pseudoinput" + (this.props.readOnly ? " readonly" : "")}>
                {inputContent}
            </div>;
        }

        const classNames = ["iw-itemspicker"];
        if (this.props.className) {
            classNames.push(this.props.className);
        }
        if (this.props.readOnly) {
            classNames.push("readonly");
        }
        return <div className={classNames.join(" ")}>
            {content}
        </div>;
    }
}
